import { DictionaryItemDto } from '@/api/generated';
import {
  DictionaryTypeOptionsTranslation,
  dictionaryTypeOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { DictionaryAddModel } from '@/views/dictionaries/list/components/dialog/model/DictionaryAdd.model.ts';
import { DictionariesListSearchFormModel } from '@/views/dictionaries/list/model/DictionariesListSearchForm.model.ts';

export type DictionariesListViewTranslation = {
  dialog: {
    add: {
      button: {
        cancel: string;
        save: string;
        saveAndAdd: string;
      };
      dictionaryTypeOptions: DictionaryTypeOptionsTranslation;
      form: Record<keyof DictionaryAddModel, string>;
      title: {
        create: string;
        update: string;
      };
    };
    delete: {
      button: {
        cancel: string;
        delete: string;
      };
      content: string;
      title: string;
    };
    eventTypeConfig: {
      button: {
        cancel: string;
        changeTemplate: string;
        clearTemplate: string;
        open: string;
        pickTemplate: string;
        save: string;
      };
      hint: string;
      noTemplate: string;
      offerPrint: string;
      offerPrintHint: string;
      saveFailed: string;
      tagPicker: {
        allSelected: string;
        clear: string;
        createTag: string;
        noMatches: string;
        nothingSelected: string;
        searchPlaceholder: string;
        selected: string;
      };
      tags: string;
      tagsHint: string;
      template: string;
      templateHint: string;
      title: string;
    };
  };
  header: {
    button: {
      add: string;
    };
    dictionaryTypePlaceholder: string;
    dictionaryTypesOptions: DictionaryTypeOptionsTranslation;
  };
  table: {
    body: Record<keyof Omit<DictionaryItemDto, 'dictionaryId'>, string> & {
      actions: string;
      dictionaryTypesOptions: DictionaryTypeOptionsTranslation;
    };
    head: Record<keyof DictionariesListSearchFormModel, string> & {
      dictionaryTypesOptions: DictionaryTypeOptionsTranslation;
    };
  };
};

export const dictionariesListViewTranslation: DictionariesListViewTranslation = {
  dialog: {
    add: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
        saveAndAdd: 'Zapisz i dodaj kolejny',
      },
      dictionaryTypeOptions: dictionaryTypeOptionsTranslation,
      form: {
        active: 'Włączony',
        name: 'Nazwa',
        type: 'Typ',
      },
      title: {
        create: 'Dodaj wpis dla słownika {{dictType}}',
        update: 'Zaktualizuj wpis',
      },
    },
    delete: {
      button: {
        cancel: 'Anuluj',
        delete: 'Usuń',
      },
      content:
        'Usunięcie spowoduje wyłączenie wartości słownika. Będzie on nadal dostepny w dotychczas wykorzystujących go elementach, lecz nie będzie można używać go przy tworzeniu nowych bądź edycji istniejących elementów',
      title: 'Potwierdź usunięcie wartości słownika',
    },
    eventTypeConfig: {
      button: {
        cancel: 'Anuluj',
        changeTemplate: 'Zmień',
        clearTemplate: 'Wyczyść',
        open: 'Konfiguracja typu wydarzenia',
        pickTemplate: 'Wybierz szablon startowy…',
        save: 'Zapisz',
      },
      hint: 'Typ wydarzenia niczego nie wymusza — podpowiada. Tagi zawężają listę dań przy układaniu menu (handlowiec jednym kliknięciem widzi z powrotem wszystkie), szablon startowy jest przy zakładaniu oferty tylko zaznaczony, a szablon wydruku wchodzi do nowej oferty wtedy, gdy nic innego go nie ustawiło.',
      noTemplate: 'Brak szablonu — ten typ nie podpowiada, od czego zacząć ofertę.',
      offerPrint: 'Domyślny szablon wydruku',
      offerPrintHint:
        'Oprawa PDF, w której oferta idzie do klienta. Dostaje ją nowa oferta tego typu, o ile szablonu nie wskazano wprost i nie ma go grupa ofert — te dwa mają pierwszeństwo. Puste = typ niczego nie podpowiada.',
      saveFailed: 'Nie udało się zapisać konfiguracji typu wydarzenia.',
      tagPicker: {
        allSelected: 'Wszystkie tagi są już zaznaczone.',
        clear: 'Wyczyść',
        createTag: 'Dodaj tag „{{name}}”',
        noMatches: 'Żaden tag nie pasuje do „{{query}}”.',
        nothingSelected: 'Nic nie zaznaczone — ten typ nie zawęża listy dań.',
        searchPlaceholder: 'Szukaj tagu…',
        selected: 'Zaznaczone tagi: {{count}}',
      },
      tags: 'Tagi dań',
      tagsHint:
        'Pełna lista docelowa: odznaczenie tagu usuwa go z typu. Pusto = ten typ niczego nie zawęża.',
      template: 'Szablon startowy oferty',
      templateHint:
        'Musi być ofertą predefiniowaną — zakładka „Predefiniowane" pokazuje dokładnie takie.',
      title: 'Typ wydarzenia: {{name}}',
    },
  },
  header: {
    button: {
      add: 'Dodaj',
    },
    dictionaryTypePlaceholder: 'Wybierz typ słownika',
    dictionaryTypesOptions: dictionaryTypeOptionsTranslation,
  },
  table: {
    body: {
      actions: '',
      dictionaryTypesOptions: dictionaryTypeOptionsTranslation,
      name: 'Nazwa',
      type: 'Typ',
    },
    head: {
      active: 'Włączone',
      dictionaryTypesOptions: dictionaryTypeOptionsTranslation,
      fullTextSearchInput: 'Szukaj',
      types: 'Typy',
    },
  },
};
